// @module NXTurn.ShoppingExtensions.IncomingEquipment
define('C3.ShoppingExtensions.RequestQuoteWizardHeader.View'
,   [
    'c3_requestquoteheader.tpl'
    
    ,   'Backbone'
    ,   'Utils'
    ,   'underscore'
    ]
, function (
    c3_requestquoteheader_tpl
    
    ,   Backbone
    ,   Utils
    ,   _
)
{
    'use strict';

    // @class NXTurn.ShoppingExtensions.IncomingEquipment.View @extends Backbone.View
    return Backbone.View.extend({

        template: c3_requestquoteheader_tpl

    ,   initialize: function (options) {
            this.application = options.application;
            this.profile = options.profile;
            //this.layout = options.layout;
            this.itemsInQuote = '';
            this.quoteItemCount = 0;
             
            var self = this;

            //this.layout.once('afterAppendView', self.loadQuoteItemCount, self);
            this.application.getLayout().once('afterAppendView', self.loadQuoteItemCount, self);
            
        }
 
    ,   render : function()
	    {
	    	this._render();

	    } 

	,   loadQuoteItemCount: function loadQuoteItemCount()
		{
			var self = this;
			if(this.profile.get('isLoggedIn') == 'T' && this.profile.get('isGuest') == 'F'){
	           
	            this.application.ProductListModule.Utils.getRequestAQuoteProductList().done(function(product_list_json){
					if(product_list_json)
					{
    					//self.itemsInQuote = product_list_json.items;
                        if(product_list_json.items && product_list_json.items.length > 9){
                            self.quoteItemCount = '9⁺';  
                        }
                        else{
                            if(product_list_json.items)
                            self.quoteItemCount = product_list_json.items.length;
                        }                    
    					
                        //console.log(self.quoteItemCount)
                        if(self.quoteItemCount > 9){
                            $('.header-mini-cart-menu-cart-legend.quote-legend').css('right','7px')

                        }
                        self.render();
					}
				});
        	}
		}    
            
        //@method getContext @return NXTurn.ShoppingExtensions.IncomingEquipment.View.Context
    ,   getContext: function getContext()
        {
        	//console.log(this.quoteItemCount)
            return {
                itemsInQuoteCount : this.quoteItemCount
            };
        }
    });
});
